<template>
  <main class="" id="main-content" role="main">
    <!-- <section-header>Medicines A-Z</section-header> -->
    <div class="">
      <div id="main" class="">
        <section id="azindex" v-if="display.includes('atoz')">
          <h1 class="qrs-header-xl">Medicines A-Z</h1>
          <div> 
            <p class="mt--small">
              Dictionary of medicines from the <a href="#" title="Click here to view the NHS.UK website (This will open in a new window)." @click="externallinkclicked('https://www.nhs.uk/medicines/')">NHS UK website</a>. Clicking on words that are underlined will search for those terms within the <a href="#" @click="externallinkclicked('https://www.nhsinform.scot/')" title="Click here to view the NHS Inform website (This will open in a new window).">NHS inform</a> website. 
            </p>
            <p class="mt-small">This list uses the generic <a href="#" @click="displayclicked('genericnames')" title="Click here for more information on generic medicine names">medicine names</a>. This is on the label printed by your pharmacy. On over the counter medicines with a brand name the generic name is on the packaging, usually in smaller print.</p>
          </div>
          <ul class="link-list-group atozlist mt--small mb--small">
            <li
              v-bind:class="{'letter':true, 'active':(q.Letter.Active)}"
              v-for="q in ma2z.MedicinesAtoZ"
              :key="q.Letter.Name"
            >
              <span
                v-if="q.Letter.Active"
                class="letter__inner activelink"
                @click.prevent="letterclicked(q.Letter.Name)"
                v-bind:title="q.Letter.Name"
              >{{q.Letter.Name}}</span>
              <span v-else class="letter__inner disabled">{{q.Letter.Name}}</span>
            </li>
          </ul>
          <div>
            <p class="mt--small">
              <a href="#" @click="externallinkclicked(nhsuk)" title="Click here to view the NHS.UK website (This will open in a new window)."><img
                :src=images.nhsuk
                alt="Content supplied by the NHS website nhs.uk"
                class="qrs-info-credit"
              /></a>
            </p>
          </div>
        </section>
        <section v-if="display==='genericnames'">
          <page-header>
            <a class="page__header__back-btn" @click="displayclicked('atoz')" title="Click here to go back to the previous section">
              <icon icon="chevron-left" />
            </a>
            <span>Medicines names</span>
          </page-header>
          <div>
            <p></p>
            <p><strong>Generic name</strong>. Each medicine has an approved name called the generic name.</p>
            <p><strong>Brand (trade) name</strong>. Some medicines, not all,  also have one or more brand names. The brand name is chosen by the company that makes it. Several companies may make the same generic medicine, each with their own brand name. For example, paracetamol is a generic name. There are several companies that make this with brand names such as Panadol&#174;, Calpol&#174;, etc.</p>
          </div>
        </section>
        <section v-if="display.includes('listbyletter')">
          <page-header>
            <a class="page__header__back-btn" @click="displayclicked('atoz')" title="Click here to go back to the previous section">
              <icon icon="chevron-left" />
            </a>
            <span>Medicines</span>
          </page-header>
          <div class="letter__label mt--small mb--xs">{{filteredMedicines[0].Name.charAt(0)}}</div>
          <ul class="link-list-group">
            <li class="link-list-group-item">
              <a
                @click.prevent="medicineclicked(q)"
                class="link-list-group-item"
                v-for="q in filteredMedicines"
                :key="q.Alias"
                title="Click here for more information on this medicine."
              >
                {{q.Name}}
                <icon icon="chevron-right" />
              </a>
            </li>
          </ul>
        </section>

        <section v-if="display.includes('medicine')">
          <page-header>
            <!-- <a class="page__header__back-btn" @click="displayclicked('listbyletter')"> -->
            <a class="page__header__back-btn" @click.prevent="medinfobackclicked" title="Click here to go back to the previous section">
              <icon icon="chevron-left" />
            </a>
            <span>Medicines</span>
          </page-header>
          <div class="content__inner pb--0">
            <div v-for="(m,idx0) in medicinedata" :key="idx0">
              <div v-if="medicinedata.length-1===idx0">
            <h2 class="mb--small">{{m.Name}}</h2>
            <div @click.prevent="handleClick">
              <div v-for="(s,idx1) in m.Detail.mainEntityOfPage" :key="idx1">
                <accordion v-bind:title="s.headline">
                  <div v-for="(s2,idx2) in s.mainEntityOfPage" :key="idx2">
                    
                    <div v-if="s2.name==='chq'">
                      <h2>{{s2.text}}</h2>
                      <div v-for="(s3,idx3) in s2.acceptedAnswer.mainEntity" :key="idx3">
                        <div v-html="s3.text"></div>
                      </div>
                    </div>
                    <div v-else v-html="s2.text"></div>
                  </div>
                </accordion>
              </div>
              <div v-if="m.Detail.relatedLink.length>0">
                <div v-if="relatedLinks('Related Condition').length>0">
                  <accordion title="Related conditions">
                  <ul>
                  <li v-for="(s,idx1) in relatedLinks('Related Condition')" :key="idx1">
                    <a href="#" @click="externallinkclicked(s.url)" title="Click here for more information on this condition.">{{s.name}}</a>
                  </li>
                  </ul>
                  </accordion>
                </div>
                <div v-if="relatedLinks('Useful Resource').length>0">
                  <accordion title="Useful resources">
                  <ul>
                  <li v-for="(s,idx1) in relatedLinks('Useful Resource')" :key="idx1">
                    <a href="#" @click="externallinkclicked(s.url)" title="Click here for more information on this resource.">{{s.name}}</a>
                  </li>
                  </ul>
                  </accordion>
                </div>
              </div>
            </div>
            <div>
              <p class="mt--small">
                <a href="#" @click="externallinkclicked(nhsuk)" title="Click here to view the NHS.UK website (This will open in a new window)."><img
                   :src=images.nhsuk 
                  alt="Content supplied by the NHS website nhs.uk"
                  class="qrs-info-credit"
                />
                </a>
              </p>
            </div>
            </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </main>
</template>

<script>
import axios from "axios";
import images from '@/helpers/encodedImages.js';
import medicines from '@/App_Data/medicines.json';

export default {
  name: "MedicineAtoZList",
  props: ['returnview'],
  mounted() {
    setTimeout(
      function () {
        let bodyhtml = document.querySelector("body").innerHTML;
        if (!bodyhtml.includes("--INAPP--")) {
          this.isapp = false;
          this.rootpath = "/";
        }
      }.bind(this),
      500
    );
    this.getdatafromfile();
  },
  data() {
    return {
      images: images,
      nhsuk:"https://www.nhs.uk",
      isapp: true,
      rootpath:"",
      display: "atoz",
      letter: "",
      ma2z: {},
      selectedmed:{},
      medicinedata: [],
    };
  },
  computed: {
    filteredMedicines() {
      var list = this.ma2z.MedicinesAtoZ.filter((m) => {
        return m.Letter.Name.match(this.letter.toUpperCase());
      });
      return list[0].Medicines;
    },
  },
  methods: {
    relatedLinks(rel){
      var res = this.selectedmed.Detail.relatedLink.filter((m) => {
        return m.linkRelationship.match(rel);
      });
      return res;
    },
    applypath(path)
    {
      return this.rootpath+path;
    },
    backtoendsequnceclicked(){
      this.$emit('returnToclicked', "endsequence");
      return false;
    },
    nhsukclicked(){
      if(this.isapp)
      {
        let d = {title:'',nodeid:-1,href:'',target:''};
          d.href=this.nhsuk;
          d.target = "_blank";
          window.Native("dataCallback",d);
          return false;
      }
      else
      {
        let win = window.open(this.nhsuk, "_blank");
          win.focus();
      }
    },
    externallinkclicked(aurl){
      let url = aurl;
      if(aurl.startsWith('/'))
      {
        url = 'https://www.nhs.uk'+aurl;
      }
      if(this.isapp)
      {
        let d = {title:'',nodeid:-1,href:'',target:''};
          d.href=url;
          d.target = "_blank";
          window.Native("dataCallback",d);
          return false;
      }
      else
      {
        let win = window.open(url, "_blank");
          win.focus();
      }
    },
    handleClick(e) {
      if (e.target.matches("a")) {
        let url = e.target.href;
        e.target.setAttribute('protected', null); //setting these attributes to null causes the app to skip over this link
				e.target.setAttribute('href', null); // i.e. not open it in an external browser

        //console.log(url);
        let bodyhtml = document.querySelector("body").innerHTML;
        if(url.startsWith("https://api.nhs.uk/medicines"))
        {
          let medalias_temp = url.replace("https://api.nhs.uk/medicines/","");
          let medalias_temp2 = medalias_temp.split("/");
          let medalias = medalias_temp2[0];
          if(medalias.length > 0)
          {
            let _firstletter = medalias.substring(0,1).toUpperCase();
            this.ma2z.MedicinesAtoZ.forEach((s)=>{
              if(s.Letter.Name ===_firstletter)
              {
                s.Medicines.forEach((m)=>{
                    if(m.Alias === medalias)
                    {
                      this.medicineclicked(m);
                    }
                });
              }
            });
          }
        }
        else if (bodyhtml.includes("--INAPP--")) {
          console.log("fire native event");
          let _u = encodeURI(url);
          axios
            .post(
              "https://127.0.0.1:8989/datastore/nav/url",
              { data: _u },
              {
                headers: {
                  "Content-Type": "application/json",
                },
              }
            )
            .then((response) => {
              console.log(response.data);
            })
            .catch((error) => {
              console.log("failed" + error);
            });
        } else {
          let win = window.open(url, "_blank");
          win.focus();
        }
      }
    },
    letterclicked(selectedletter) {
      this.letter = selectedletter;
      this.display = "listbyletter";
    },
    medicineclicked(med) {
      ///let obj = JSON.parse(med.Detail);
      //console.log(obj);
      this.selectedmed=med;
      this.medicinedata.push(med);
      this.display = "medicine";
      // this.$refs['info'].firstChild.addEventListener('click', function(event) {
      //   event.preventDefault();
      //   console.log('clicked: ', event.target);
      // });
    },
    medinfobackclicked(){
      if(this.medicinedata.length > 1)
      {
          this.medicinedata.pop();
      }
      else
      {
        this.display = "listbyletter";
      }
    },
    displayclicked(display) {
      this.display = display;
    },
    getdatafromfile() {
      console.log('getdatafromfile');
			this.ma2z = medicines;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../../scss/layouts/header.scss";
@import "../../../scss/elements/_panels.scss";
@import "../../../scss/elements/_listing.scss";
@import "../../../scss/elements/_buttons.scss";
</style>
